import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=172ac8cd&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=172ac8cd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CmsPage: require('/var/www/ct-frontend/ct-front-20261029043307/node_modules/sitis-nuxt/lib/cms/CmsPage.vue').default})
